import { onMounted, onUnmounted } from 'vue'

/**
 * Composable for managing mobile keyboard behavior
 * Ensures keyboard doesn't cover input fields and provides accessory bar
 */
export function useKeyboardManagement() {
  const isMobile = window.Capacitor?.isNativePlatform?.()

  onMounted(async () => {
    if (!isMobile) return

    try {
      const { Keyboard } = await import('@capacitor/keyboard')

      // Show accessory bar (Done/Next buttons) above keyboard
      await Keyboard.setAccessoryBarVisible({ isVisible: true })

      // Allow page scrolling when keyboard appears
      await Keyboard.setScroll({ isDisabled: false })
    } catch (error) {
      console.warn('Keyboard plugin not available:', error)
    }
  })

  // Keyboard cleanup is automatic, no need for onUnmounted

  return {
    isMobile
  }
}
